import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

export const StatusDot = ({ active }) => (
  <div className={classNames(styles.statusDot, active && styles.active)}>
    &bull;
  </div>
);
